import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateAccessDataProtection = document.createElement('template');

templateAccessDataProtection.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-1-3-ratio">
    <h2 class="display-2 widget-title">
        <span id="accessDataProtectionTitle"></span>
        ${renderErrorStateIcon()}
    </h2>

    <div class="content">
        <div id="accessDataProtectionChart" class="access-data-protection-chart"></div>
        <gz-loader class="widget-loading" rows="5"></gz-loader>
     </div>
  </div>
`;
